class ReqPotentialFiles {
	async downloadFile(key) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/performance_file?key=${key}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async getEmployeeList(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/employee_performance_files/${companyId}`, {
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async getUploadRoute(employeeId, companyId, fileName) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/upload_performance_file/${employeeId}`, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify({
				'companyId': companyId,
				'fileName': fileName,
			}),
		})

		return response.json()
	}
	async deleteFile(fileId) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/performance_file/${fileId}`, {
			method: 'DELETE',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async sendFile(file, route) {
		const response = await fetch(route, {
			method: 'PUT',
			headers: {
				'Content-Type': file.type,
			},
			body: file,
		})

		if (!response.ok) {
			throw new Error(`Erro ao enviar o arquivo: ${response.statusText}`)
		}

		return response
	}
}
export default new ReqPotentialFiles()
